import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TemplateService } from '../../services/template.service';
import { DialogService } from '../../services/dialog.service';
import { deepCopy } from '@delon/util';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-tpl-operate',
  template: `
    <div class="operate-group">
      <nz-switch
        *ngIf="item.id > 0 && !item.isDefault"
        [ngModel]="item.state == 1 ? true : false"
        nzSize="default"
        nzCheckedChildren="开启"
        nzUnCheckedChildren="停用"
        [name]="'state' + index"
        (ngModelChange)="changeTemplateState($event, index)"
      ></nz-switch>

      <span class="iconfont icon-add span-icon pointer" (click)="addTemplate()" nz-popover nzPopoverContent="添加模板" nzPopoverPlacement="top"> </span>

      <span
        *ngIf="0 !== index && source.useTmplMethod == 1"
        class="iconfont icon-up-arrow span-icon pointer"
        nz-popover
        (click)="moveTemplate(index, index - 1)"
        nzPopoverContent="优先级上移"
        nzPopoverPlacement="top"
      ></span>
      <span
        *ngIf="source.templates.length - 1 !== index && source.useTmplMethod == 1"
        class="iconfont icon-down-Arrow span-icon pointer"
        nz-popover
        nzPopoverContent="优先级下移"
        (click)="moveTemplate(index, index + 1)"
        nzPopoverPlacement="top"
      ></span>

      <!-- 智能模板 ：不是默认才可以删 -->
      <!-- 普通模板：因为没有执行条件，所以可以删 -->
      <icc-image
        class="icc-image pointer"
        src="assets/images/btnIcon/delete_red.png"
        nz-popconfirm
        *ngIf="source.useTmplMethod == 2 || (item.state !== 4 && !item.isDefault)"
        nzPopconfirmTitle="是否确认删除该模板?"
        (nzOnConfirm)="removeTemplate(index)"
      >
      </icc-image>
    </div>
  `,
})
export class IccTplOperateComponent implements OnInit {
  /** 当前模板的索引 */
  @Input() index: any;
  /** 表单的校验结果 */
  @Input() valid: boolean;
  /** 消息类型 */
  @Input() type: number;
  /** 新增的模板 */
  @Input() template: any;
  /** 模板更新后的回调 */
  @Output() update = new EventEmitter<any>();

  /** 当前消息类型的资源 */
  source: any;
  /** 当前消息类型下的模板 */
  item: any;

  constructor(private templateService: TemplateService, private dialogService: DialogService) {}

  ngOnInit() {
    this.source = this.templateService.getMsg(this.type) || [];
    this.item = this.templateService.getTpl(this.type)[this.index] || [];
  }

  /** 添加模板 */
  addTemplate() {
    const target = this.process();
    this.templateService.addTemplate(target, this.type);
    this.update.next(target);
  }
  /** 移动模板 */
  moveTemplate(current: number, next: number) {
    // if (!this.valid) {
    //   this.dialogService.notification.warning('注意', `请确保所有模板内容输入正确后再调整优先级!`);
    //   return;
    // }
    this.templateService.moveTemplate(current, next, this.type);
  }
  /** 删除模板 */
  removeTemplate(index: number) {
    this.templateService.removeTemplate(index, this.type);
  }
  /** 改变模板的状态模板 */
  changeTemplateState(isOpen: boolean, index: number): void {
    this.templateService.changeTemplateState(isOpen, index, this.type);
  }
  /** 模板预处理 */
  process() {
    const templates = this.templateService.getTpl(this.type);
    const standardTemplate = this.templateService.getStandardTpl(this.type);
    let count = templates.length + 1;
    return {
      ...deepCopy(standardTemplate),
      bizTypeId: this.source.id,
      msgType: this.type,
      name: '模板名称' + count,
    };
  }
}
